var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("e-sidebar", {
        attrs: {
          title: _vm.isEdit ? _vm.$t("Editar Cartão") : _vm.$t("Novo Cartão"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: {
          save: _vm.saveAdminCard,
          hidden: function ($event) {
            _vm.showSidebar = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "FormulateForm",
                  { ref: "adminCardForm", attrs: { name: "adminCardForm" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: "manage_admin_card_sidebar-card_number",
                                type: "text",
                                label: _vm.$t("Número do cartão"),
                                instruction: _vm.$t(
                                  "Formato hexadecimal (ex.: DC112A9A) ou use o botão Ler cartão"
                                ),
                                validation:
                                  "required|matches:/^[0-9A-Fa-f]{8}$/",
                                "validation-messages": {
                                  matches: _vm.$t(
                                    "Informe 8 caracteres hexadecimais (ex.: DC112A9A)"
                                  ),
                                },
                              },
                              on: { input: _vm.onCardNumberInput },
                              model: {
                                value: _vm.localAdminCard.cardNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localAdminCard,
                                    "cardNumber",
                                    $$v
                                  )
                                },
                                expression: "localAdminCard.cardNumber",
                              },
                            }),
                            _c("e-button", {
                              staticClass: "mb-1",
                              attrs: {
                                variant: "outline-primary",
                                icon: "credit-card-2-front",
                                text: _vm.$t("Ler cartão"),
                              },
                              on: { click: _vm.openReadCardModal },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-user-search", {
                              staticClass: "required",
                              attrs: {
                                id: "manage_admin_card_sidebar-user",
                                required: true,
                                label: _vm.$t("Usuário"),
                                "default-options": _vm.userDefaultOptions,
                              },
                              model: {
                                value: _vm.localAdminCard.userId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localAdminCard, "userId", $$v)
                                },
                                expression: "localAdminCard.userId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-store-combo", {
                              attrs: {
                                id: "manage_admin_card_sidebar-full_access_stores",
                                required: false,
                                multiple: true,
                                "select-single-option": false,
                                label: _vm.$t(
                                  "Lojas com acesso total (todas as SmartPos)"
                                ),
                                instruction: _vm.$t(
                                  "O cartão acessa todas as SmartPos (atuais e futuras) das lojas selecionadas"
                                ),
                                placeholder: _vm.$t("Selecione"),
                              },
                              model: {
                                value: _vm.localAdminCard.storeIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localAdminCard, "storeIds", $$v)
                                },
                                expression: "localAdminCard.storeIds",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-store-combo", {
                              attrs: {
                                id: "manage_admin_card_sidebar-store",
                                required: false,
                                "select-single-option": false,
                                label: _vm.$t(
                                  "Loja (filtro dos PDVs específicos)"
                                ),
                                placeholder: _vm.$t("Todas"),
                              },
                              model: {
                                value: _vm.storeFilter,
                                callback: function ($$v) {
                                  _vm.storeFilter = $$v
                                },
                                expression: "storeFilter",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "manage_admin_card_sidebar-pay_boxes",
                                type: "vue-select",
                                multiple: true,
                                label: _vm.$t(
                                  "Caixas (PDV) específicos autorizados"
                                ),
                                instruction: _vm.$t(
                                  "Acesso pontual a PDVs específicos, além das lojas com acesso total"
                                ),
                                placeholder: _vm.$t("Selecione"),
                                options: _vm.filteredPayBoxesOptions,
                              },
                              model: {
                                value: _vm.localAdminCard.payBoxIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localAdminCard, "payBoxIds", $$v)
                                },
                                expression: "localAdminCard.payBoxIds",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "manage_admin_card_sidebar-active",
                                type: "switch",
                                label: _vm.$t("Ativo"),
                              },
                              model: {
                                value: _vm.localAdminCard.active,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localAdminCard, "active", $$v)
                                },
                                expression: "localAdminCard.active",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "readAdminCardModal",
            title: _vm.$t("Ler cartão"),
            centered: "",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          on: { shown: _vm.focusReadInput },
          model: {
            value: _vm.showReadCardModal,
            callback: function ($$v) {
              _vm.showReadCardModal = $$v
            },
            expression: "showReadCardModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "Aproxime o cartão do leitor. O código lido será convertido automaticamente."
                  )
                ) +
                " "
            ),
          ]),
          _c("b-form-input", {
            ref: "readCardInput",
            attrs: {
              placeholder: _vm.$t("Aguardando leitura..."),
              autocomplete: "off",
            },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.applyReadCard($event)
              },
            },
            model: {
              value: _vm.readCardValue,
              callback: function ($$v) {
                _vm.readCardValue = $$v
              },
              expression: "readCardValue",
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-end mt-1" },
            [
              _c("e-button", {
                staticClass: "mr-1",
                attrs: { variant: "outline-primary", text: _vm.$t("Cancelar") },
                on: {
                  click: function ($event) {
                    _vm.showReadCardModal = false
                  },
                },
              }),
              _c("e-button", {
                attrs: { variant: "primary", text: _vm.$t("Confirmar") },
                on: { click: _vm.applyReadCard },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }